export default "__VITE_ASSET__$J36gSsu__"